import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Register() {
  const { t } = useTranslation("welcome");

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <CardContent>
        <Typography variant="h5" gutterBottom>
          {t("register.title")}
        </Typography>
        <Typography gutterBottom>{t("register.info")}</Typography>
      </CardContent>
      <CardActions>
        <Button
          color="secondary"
          variant="contained"
          fullWidth
          href="https://rescuetablet.de/registrieren"
        >
          {t("register.action")}
        </Button>
      </CardActions>
    </Card>
  );
}
